import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";


const CMO = () => {
    const location = useLocation();
    const [title, setTitle] = useState("")
    const [loading, setLoading] = useState(false);
    
  
  useEffect(()=>{
    let currentPath = location.pathname;
    currentPath = currentPath.split("/")[1]

    setTitle(currentPath);
  },[])
  useEffect(() => {
      window.scrollTo(0, 0);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); // Adjust loading duration
  
      return () => clearTimeout(timer);
    }, []);

  return (
    <React.Fragment>
          {loading ? (
                  
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100vh",
                            }}
                          >
                            <Hourglass
                              height={80}
                              width={80}
                              color="#01458e"
                              ariaLabel="loading-content"
                            />
                          </div>
                        ) : (
      <div>
      <HeaderMobile/>
        <Breadcrumb heading={title} bTitle={title}/>
      <Container className="galleryRow ">
      
        <div>
            <h3>Coming Soon...</h3>
        </div>
      </Container>
      </div>
       )}
    </React.Fragment>
  );
};

export default CMO;
